export const RETAIL_AUTOMATION_STEPS = {
  TEMPLATE: 'template',
  HOTSPOT: 'hotspot',
  CAMERA: 'camera',
  PRODUCT: 'product',
  ARTWORK: 'artwork',
};

export const NEW_RETAIL_AUTOMATION_ID = 'new';

// Dummy Retail Automation data
export const TEST_RETAIL_AUTOMATION_TEMPLATE_1 = {
  blenderAssetBundleDatas: [
    {
      assetBundleName: 'Drs Tv 008',
      objectName: '1@10295',
      blenderAssetbundleId: '10295',
      parentName: 'drs_tv_008',
      id: '10295',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_008',
          childName: '1_tv_panel_008_1@10295',
        },
        {
          actualchildName: 'tvv_frame_008',
          childName: '1_tvv_frame_008_1@10295',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_008_1@10295',
          materialName: '1@10295_0',
        },
        {
          childName: '1_tvv_frame_008_1@10295',
          materialName: '1@10295_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 006',
      objectName: '1@10293',
      blenderAssetbundleId: '10293',
      parentName: 'drs_tv_006',
      id: '10293',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_006',
          childName: '1_tv_panel_006_1@10293',
        },
        {
          actualchildName: 'tvv_frame_006',
          childName: '1_tvv_frame_006_1@10293',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_006_1@10293',
          materialName: '1@10293_0',
        },
        {
          childName: '1_tvv_frame_006_1@10293',
          materialName: '1@10293_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '1@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '1_ceiling_light_emission_1_1@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '1_ceiling_light_frame_1_1@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_ceiling_light_emission_1_1@10280',
          materialName: '1@10280_0',
        },
        {
          childName: '1_ceiling_light_frame_1_1@10280',
          materialName: '1@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '2@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '2',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '2_ceiling_light_emission_1_2@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '2_ceiling_light_frame_1_2@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '2_ceiling_light_emission_1_2@10280',
          materialName: '2@10280_0',
        },
        {
          childName: '2_ceiling_light_frame_1_2@10280',
          materialName: '2@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '3@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '3',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '3_ceiling_light_emission_1_3@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '3_ceiling_light_frame_1_3@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '3_ceiling_light_emission_1_3@10280',
          materialName: '3@10280_0',
        },
        {
          childName: '3_ceiling_light_frame_1_3@10280',
          materialName: '3@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '4@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '4',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '4_ceiling_light_emission_1_4@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '4_ceiling_light_frame_1_4@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '4_ceiling_light_emission_1_4@10280',
          materialName: '4@10280_0',
        },
        {
          childName: '4_ceiling_light_frame_1_4@10280',
          materialName: '4@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '5@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '5',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '5_ceiling_light_emission_1_5@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '5_ceiling_light_frame_1_5@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '5_ceiling_light_emission_1_5@10280',
          materialName: '5@10280_0',
        },
        {
          childName: '5_ceiling_light_frame_1_5@10280',
          materialName: '5@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '6@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '6',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '6_ceiling_light_emission_1_6@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '6_ceiling_light_frame_1_6@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '6_ceiling_light_emission_1_6@10280',
          materialName: '6@10280_0',
        },
        {
          childName: '6_ceiling_light_frame_1_6@10280',
          materialName: '6@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '7@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '7',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '7_ceiling_light_emission_1_7@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '7_ceiling_light_frame_1_7@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '7_ceiling_light_emission_1_7@10280',
          materialName: '7@10280_0',
        },
        {
          childName: '7_ceiling_light_frame_1_7@10280',
          materialName: '7@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '8@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '8',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '8_ceiling_light_emission_1_8@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '8_ceiling_light_frame_1_8@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '8_ceiling_light_emission_1_8@10280',
          materialName: '8@10280_0',
        },
        {
          childName: '8_ceiling_light_frame_1_8@10280',
          materialName: '8@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '9@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '9',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '9_ceiling_light_emission_1_9@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '9_ceiling_light_frame_1_9@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '9_ceiling_light_emission_1_9@10280',
          materialName: '9@10280_0',
        },
        {
          childName: '9_ceiling_light_frame_1_9@10280',
          materialName: '9@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '10@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '10',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '10_ceiling_light_emission_1_10@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '10_ceiling_light_frame_1_10@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '10_ceiling_light_emission_1_10@10280',
          materialName: '10@10280_0',
        },
        {
          childName: '10_ceiling_light_frame_1_10@10280',
          materialName: '10@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '11@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '11',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '11_ceiling_light_emission_1_11@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '11_ceiling_light_frame_1_11@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '11_ceiling_light_emission_1_11@10280',
          materialName: '11@10280_0',
        },
        {
          childName: '11_ceiling_light_frame_1_11@10280',
          materialName: '11@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '12@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '12',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '12_ceiling_light_emission_1_12@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '12_ceiling_light_frame_1_12@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '12_ceiling_light_emission_1_12@10280',
          materialName: '12@10280_0',
        },
        {
          childName: '12_ceiling_light_frame_1_12@10280',
          materialName: '12@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '13@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '13',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '13_ceiling_light_emission_1_13@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '13_ceiling_light_frame_1_13@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '13_ceiling_light_emission_1_13@10280',
          materialName: '13@10280_0',
        },
        {
          childName: '13_ceiling_light_frame_1_13@10280',
          materialName: '13@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '14@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '14',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '14_ceiling_light_emission_1_14@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '14_ceiling_light_frame_1_14@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '14_ceiling_light_emission_1_14@10280',
          materialName: '14@10280_0',
        },
        {
          childName: '14_ceiling_light_frame_1_14@10280',
          materialName: '14@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '15@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '15',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '15_ceiling_light_emission_1_15@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '15_ceiling_light_frame_1_15@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '15_ceiling_light_emission_1_15@10280',
          materialName: '15@10280_0',
        },
        {
          childName: '15_ceiling_light_frame_1_15@10280',
          materialName: '15@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '16@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '16',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '16_ceiling_light_emission_1_16@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '16_ceiling_light_frame_1_16@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '16_ceiling_light_emission_1_16@10280',
          materialName: '16@10280_0',
        },
        {
          childName: '16_ceiling_light_frame_1_16@10280',
          materialName: '16@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '17@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '17',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '17_ceiling_light_emission_1_17@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '17_ceiling_light_frame_1_17@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '17_ceiling_light_emission_1_17@10280',
          materialName: '17@10280_0',
        },
        {
          childName: '17_ceiling_light_frame_1_17@10280',
          materialName: '17@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '18@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '18',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '18_ceiling_light_emission_1_18@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '18_ceiling_light_frame_1_18@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '18_ceiling_light_emission_1_18@10280',
          materialName: '18@10280_0',
        },
        {
          childName: '18_ceiling_light_frame_1_18@10280',
          materialName: '18@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '19@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '19',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '19_ceiling_light_emission_1_19@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '19_ceiling_light_frame_1_19@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '19_ceiling_light_emission_1_19@10280',
          materialName: '19@10280_0',
        },
        {
          childName: '19_ceiling_light_frame_1_19@10280',
          materialName: '19@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '20@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '20',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '20_ceiling_light_emission_1_20@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '20_ceiling_light_frame_1_20@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '20_ceiling_light_emission_1_20@10280',
          materialName: '20@10280_0',
        },
        {
          childName: '20_ceiling_light_frame_1_20@10280',
          materialName: '20@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '21@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '21',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '21_ceiling_light_emission_1_21@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '21_ceiling_light_frame_1_21@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '21_ceiling_light_emission_1_21@10280',
          materialName: '21@10280_0',
        },
        {
          childName: '21_ceiling_light_frame_1_21@10280',
          materialName: '21@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '22@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '22',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '22_ceiling_light_emission_1_22@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '22_ceiling_light_frame_1_22@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '22_ceiling_light_emission_1_22@10280',
          materialName: '22@10280_0',
        },
        {
          childName: '22_ceiling_light_frame_1_22@10280',
          materialName: '22@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '23@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '23',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '23_ceiling_light_emission_1_23@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '23_ceiling_light_frame_1_23@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '23_ceiling_light_emission_1_23@10280',
          materialName: '23@10280_0',
        },
        {
          childName: '23_ceiling_light_frame_1_23@10280',
          materialName: '23@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '24@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '24',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '24_ceiling_light_emission_1_24@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '24_ceiling_light_frame_1_24@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '24_ceiling_light_emission_1_24@10280',
          materialName: '24@10280_0',
        },
        {
          childName: '24_ceiling_light_frame_1_24@10280',
          materialName: '24@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '25@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '25',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '25_ceiling_light_emission_1_25@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '25_ceiling_light_frame_1_25@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '25_ceiling_light_emission_1_25@10280',
          materialName: '25@10280_0',
        },
        {
          childName: '25_ceiling_light_frame_1_25@10280',
          materialName: '25@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '26@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '26',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '26_ceiling_light_emission_1_26@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '26_ceiling_light_frame_1_26@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '26_ceiling_light_emission_1_26@10280',
          materialName: '26@10280_0',
        },
        {
          childName: '26_ceiling_light_frame_1_26@10280',
          materialName: '26@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '27@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '27',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '27_ceiling_light_emission_1_27@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '27_ceiling_light_frame_1_27@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '27_ceiling_light_emission_1_27@10280',
          materialName: '27@10280_0',
        },
        {
          childName: '27_ceiling_light_frame_1_27@10280',
          materialName: '27@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '28@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '28',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '28_ceiling_light_emission_1_28@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '28_ceiling_light_frame_1_28@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '28_ceiling_light_emission_1_28@10280',
          materialName: '28@10280_0',
        },
        {
          childName: '28_ceiling_light_frame_1_28@10280',
          materialName: '28@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '29@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '29',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '29_ceiling_light_emission_1_29@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '29_ceiling_light_frame_1_29@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '29_ceiling_light_emission_1_29@10280',
          materialName: '29@10280_0',
        },
        {
          childName: '29_ceiling_light_frame_1_29@10280',
          materialName: '29@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '30@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '30',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '30_ceiling_light_emission_1_30@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '30_ceiling_light_frame_1_30@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '30_ceiling_light_emission_1_30@10280',
          materialName: '30@10280_0',
        },
        {
          childName: '30_ceiling_light_frame_1_30@10280',
          materialName: '30@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '31@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '31',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '31_ceiling_light_emission_1_31@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '31_ceiling_light_frame_1_31@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '31_ceiling_light_emission_1_31@10280',
          materialName: '31@10280_0',
        },
        {
          childName: '31_ceiling_light_frame_1_31@10280',
          materialName: '31@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '32@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '32',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '32_ceiling_light_emission_1_32@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '32_ceiling_light_frame_1_32@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '32_ceiling_light_emission_1_32@10280',
          materialName: '32@10280_0',
        },
        {
          childName: '32_ceiling_light_frame_1_32@10280',
          materialName: '32@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '33@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '33',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '33_ceiling_light_emission_1_33@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '33_ceiling_light_frame_1_33@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '33_ceiling_light_emission_1_33@10280',
          materialName: '33@10280_0',
        },
        {
          childName: '33_ceiling_light_frame_1_33@10280',
          materialName: '33@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '34@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '34',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '34_ceiling_light_emission_1_34@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '34_ceiling_light_frame_1_34@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '34_ceiling_light_emission_1_34@10280',
          materialName: '34@10280_0',
        },
        {
          childName: '34_ceiling_light_frame_1_34@10280',
          materialName: '34@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '35@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '35',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '35_ceiling_light_emission_1_35@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '35_ceiling_light_frame_1_35@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '35_ceiling_light_emission_1_35@10280',
          materialName: '35@10280_0',
        },
        {
          childName: '35_ceiling_light_frame_1_35@10280',
          materialName: '35@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '36@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '36',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '36_ceiling_light_emission_1_36@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '36_ceiling_light_frame_1_36@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '36_ceiling_light_emission_1_36@10280',
          materialName: '36@10280_0',
        },
        {
          childName: '36_ceiling_light_frame_1_36@10280',
          materialName: '36@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '37@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '37',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '37_ceiling_light_emission_1_37@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '37_ceiling_light_frame_1_37@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '37_ceiling_light_emission_1_37@10280',
          materialName: '37@10280_0',
        },
        {
          childName: '37_ceiling_light_frame_1_37@10280',
          materialName: '37@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '38@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '38',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '38_ceiling_light_emission_1_38@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '38_ceiling_light_frame_1_38@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '38_ceiling_light_emission_1_38@10280',
          materialName: '38@10280_0',
        },
        {
          childName: '38_ceiling_light_frame_1_38@10280',
          materialName: '38@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '39@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '39',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '39_ceiling_light_emission_1_39@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '39_ceiling_light_frame_1_39@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '39_ceiling_light_emission_1_39@10280',
          materialName: '39@10280_0',
        },
        {
          childName: '39_ceiling_light_frame_1_39@10280',
          materialName: '39@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '40@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '40',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '40_ceiling_light_emission_1_40@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '40_ceiling_light_frame_1_40@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '40_ceiling_light_emission_1_40@10280',
          materialName: '40@10280_0',
        },
        {
          childName: '40_ceiling_light_frame_1_40@10280',
          materialName: '40@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '41@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '41',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '41_ceiling_light_emission_1_41@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '41_ceiling_light_frame_1_41@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '41_ceiling_light_emission_1_41@10280',
          materialName: '41@10280_0',
        },
        {
          childName: '41_ceiling_light_frame_1_41@10280',
          materialName: '41@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '42@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '42',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '42_ceiling_light_emission_1_42@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '42_ceiling_light_frame_1_42@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '42_ceiling_light_emission_1_42@10280',
          materialName: '42@10280_0',
        },
        {
          childName: '42_ceiling_light_frame_1_42@10280',
          materialName: '42@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '43@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '43',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '43_ceiling_light_emission_1_43@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '43_ceiling_light_frame_1_43@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '43_ceiling_light_emission_1_43@10280',
          materialName: '43@10280_0',
        },
        {
          childName: '43_ceiling_light_frame_1_43@10280',
          materialName: '43@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '44@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '44',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '44_ceiling_light_emission_1_44@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '44_ceiling_light_frame_1_44@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '44_ceiling_light_emission_1_44@10280',
          materialName: '44@10280_0',
        },
        {
          childName: '44_ceiling_light_frame_1_44@10280',
          materialName: '44@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '45@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '45',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '45_ceiling_light_emission_1_45@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '45_ceiling_light_frame_1_45@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '45_ceiling_light_emission_1_45@10280',
          materialName: '45@10280_0',
        },
        {
          childName: '45_ceiling_light_frame_1_45@10280',
          materialName: '45@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '46@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '46',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '46_ceiling_light_emission_1_46@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '46_ceiling_light_frame_1_46@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '46_ceiling_light_emission_1_46@10280',
          materialName: '46@10280_0',
        },
        {
          childName: '46_ceiling_light_frame_1_46@10280',
          materialName: '46@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '47@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '47',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '47_ceiling_light_emission_1_47@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '47_ceiling_light_frame_1_47@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '47_ceiling_light_emission_1_47@10280',
          materialName: '47@10280_0',
        },
        {
          childName: '47_ceiling_light_frame_1_47@10280',
          materialName: '47@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '48@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '48',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '48_ceiling_light_emission_1_48@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '48_ceiling_light_frame_1_48@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '48_ceiling_light_emission_1_48@10280',
          materialName: '48@10280_0',
        },
        {
          childName: '48_ceiling_light_frame_1_48@10280',
          materialName: '48@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '49@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '49',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '49_ceiling_light_emission_1_49@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '49_ceiling_light_frame_1_49@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '49_ceiling_light_emission_1_49@10280',
          materialName: '49@10280_0',
        },
        {
          childName: '49_ceiling_light_frame_1_49@10280',
          materialName: '49@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '50@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '50',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '50_ceiling_light_emission_1_50@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '50_ceiling_light_frame_1_50@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '50_ceiling_light_emission_1_50@10280',
          materialName: '50@10280_0',
        },
        {
          childName: '50_ceiling_light_frame_1_50@10280',
          materialName: '50@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '51@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '51',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '51_ceiling_light_emission_1_51@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '51_ceiling_light_frame_1_51@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '51_ceiling_light_emission_1_51@10280',
          materialName: '51@10280_0',
        },
        {
          childName: '51_ceiling_light_frame_1_51@10280',
          materialName: '51@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '52@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '52',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '52_ceiling_light_emission_1_52@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '52_ceiling_light_frame_1_52@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '52_ceiling_light_emission_1_52@10280',
          materialName: '52@10280_0',
        },
        {
          childName: '52_ceiling_light_frame_1_52@10280',
          materialName: '52@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '53@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '53',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '53_ceiling_light_emission_1_53@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '53_ceiling_light_frame_1_53@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '53_ceiling_light_emission_1_53@10280',
          materialName: '53@10280_0',
        },
        {
          childName: '53_ceiling_light_frame_1_53@10280',
          materialName: '53@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '54@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '54',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '54_ceiling_light_emission_1_54@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '54_ceiling_light_frame_1_54@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '54_ceiling_light_emission_1_54@10280',
          materialName: '54@10280_0',
        },
        {
          childName: '54_ceiling_light_frame_1_54@10280',
          materialName: '54@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '55@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '55',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '55_ceiling_light_emission_1_55@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '55_ceiling_light_frame_1_55@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '55_ceiling_light_emission_1_55@10280',
          materialName: '55@10280_0',
        },
        {
          childName: '55_ceiling_light_frame_1_55@10280',
          materialName: '55@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '56@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '56',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '56_ceiling_light_emission_1_56@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '56_ceiling_light_frame_1_56@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '56_ceiling_light_emission_1_56@10280',
          materialName: '56@10280_0',
        },
        {
          childName: '56_ceiling_light_frame_1_56@10280',
          materialName: '56@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '57@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '57',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '57_ceiling_light_emission_1_57@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '57_ceiling_light_frame_1_57@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '57_ceiling_light_emission_1_57@10280',
          materialName: '57@10280_0',
        },
        {
          childName: '57_ceiling_light_frame_1_57@10280',
          materialName: '57@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '58@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '58',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '58_ceiling_light_emission_1_58@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '58_ceiling_light_frame_1_58@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '58_ceiling_light_emission_1_58@10280',
          materialName: '58@10280_0',
        },
        {
          childName: '58_ceiling_light_frame_1_58@10280',
          materialName: '58@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '59@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '59',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '59_ceiling_light_emission_1_59@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '59_ceiling_light_frame_1_59@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '59_ceiling_light_emission_1_59@10280',
          materialName: '59@10280_0',
        },
        {
          childName: '59_ceiling_light_frame_1_59@10280',
          materialName: '59@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '60@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '60',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '60_ceiling_light_emission_1_60@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '60_ceiling_light_frame_1_60@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '60_ceiling_light_emission_1_60@10280',
          materialName: '60@10280_0',
        },
        {
          childName: '60_ceiling_light_frame_1_60@10280',
          materialName: '60@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '61@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '61',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '61_ceiling_light_emission_1_61@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '61_ceiling_light_frame_1_61@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '61_ceiling_light_emission_1_61@10280',
          materialName: '61@10280_0',
        },
        {
          childName: '61_ceiling_light_frame_1_61@10280',
          materialName: '61@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '62@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '62',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '62_ceiling_light_emission_1_62@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '62_ceiling_light_frame_1_62@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '62_ceiling_light_emission_1_62@10280',
          materialName: '62@10280_0',
        },
        {
          childName: '62_ceiling_light_frame_1_62@10280',
          materialName: '62@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '63@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '63',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '63_ceiling_light_emission_1_63@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '63_ceiling_light_frame_1_63@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '63_ceiling_light_emission_1_63@10280',
          materialName: '63@10280_0',
        },
        {
          childName: '63_ceiling_light_frame_1_63@10280',
          materialName: '63@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '64@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '64',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '64_ceiling_light_emission_1_64@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '64_ceiling_light_frame_1_64@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '64_ceiling_light_emission_1_64@10280',
          materialName: '64@10280_0',
        },
        {
          childName: '64_ceiling_light_frame_1_64@10280',
          materialName: '64@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '65@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '65',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '65_ceiling_light_emission_1_65@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '65_ceiling_light_frame_1_65@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '65_ceiling_light_emission_1_65@10280',
          materialName: '65@10280_0',
        },
        {
          childName: '65_ceiling_light_frame_1_65@10280',
          materialName: '65@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '66@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '66',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '66_ceiling_light_emission_1_66@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '66_ceiling_light_frame_1_66@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '66_ceiling_light_emission_1_66@10280',
          materialName: '66@10280_0',
        },
        {
          childName: '66_ceiling_light_frame_1_66@10280',
          materialName: '66@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '67@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '67',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '67_ceiling_light_emission_1_67@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '67_ceiling_light_frame_1_67@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '67_ceiling_light_emission_1_67@10280',
          materialName: '67@10280_0',
        },
        {
          childName: '67_ceiling_light_frame_1_67@10280',
          materialName: '67@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '68@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '68',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '68_ceiling_light_emission_1_68@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '68_ceiling_light_frame_1_68@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '68_ceiling_light_emission_1_68@10280',
          materialName: '68@10280_0',
        },
        {
          childName: '68_ceiling_light_frame_1_68@10280',
          materialName: '68@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '69@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '69',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '69_ceiling_light_emission_1_69@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '69_ceiling_light_frame_1_69@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '69_ceiling_light_emission_1_69@10280',
          materialName: '69@10280_0',
        },
        {
          childName: '69_ceiling_light_frame_1_69@10280',
          materialName: '69@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '70@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '70',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '70_ceiling_light_emission_1_70@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '70_ceiling_light_frame_1_70@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '70_ceiling_light_emission_1_70@10280',
          materialName: '70@10280_0',
        },
        {
          childName: '70_ceiling_light_frame_1_70@10280',
          materialName: '70@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '71@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '71',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '71_ceiling_light_emission_1_71@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '71_ceiling_light_frame_1_71@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '71_ceiling_light_emission_1_71@10280',
          materialName: '71@10280_0',
        },
        {
          childName: '71_ceiling_light_frame_1_71@10280',
          materialName: '71@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '72@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '72',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '72_ceiling_light_emission_1_72@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '72_ceiling_light_frame_1_72@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '72_ceiling_light_emission_1_72@10280',
          materialName: '72@10280_0',
        },
        {
          childName: '72_ceiling_light_frame_1_72@10280',
          materialName: '72@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '73@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '73',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '73_ceiling_light_emission_1_73@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '73_ceiling_light_frame_1_73@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '73_ceiling_light_emission_1_73@10280',
          materialName: '73@10280_0',
        },
        {
          childName: '73_ceiling_light_frame_1_73@10280',
          materialName: '73@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '74@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '74',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '74_ceiling_light_emission_1_74@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '74_ceiling_light_frame_1_74@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '74_ceiling_light_emission_1_74@10280',
          materialName: '74@10280_0',
        },
        {
          childName: '74_ceiling_light_frame_1_74@10280',
          materialName: '74@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '75@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '75',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '75_ceiling_light_emission_1_75@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '75_ceiling_light_frame_1_75@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '75_ceiling_light_emission_1_75@10280',
          materialName: '75@10280_0',
        },
        {
          childName: '75_ceiling_light_frame_1_75@10280',
          materialName: '75@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '76@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '76',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '76_ceiling_light_emission_1_76@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '76_ceiling_light_frame_1_76@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '76_ceiling_light_emission_1_76@10280',
          materialName: '76@10280_0',
        },
        {
          childName: '76_ceiling_light_frame_1_76@10280',
          materialName: '76@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '77@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '77',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '77_ceiling_light_emission_1_77@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '77_ceiling_light_frame_1_77@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '77_ceiling_light_emission_1_77@10280',
          materialName: '77@10280_0',
        },
        {
          childName: '77_ceiling_light_frame_1_77@10280',
          materialName: '77@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '78@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '78',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '78_ceiling_light_emission_1_78@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '78_ceiling_light_frame_1_78@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '78_ceiling_light_emission_1_78@10280',
          materialName: '78@10280_0',
        },
        {
          childName: '78_ceiling_light_frame_1_78@10280',
          materialName: '78@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '79@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '79',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '79_ceiling_light_emission_1_79@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '79_ceiling_light_frame_1_79@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '79_ceiling_light_emission_1_79@10280',
          materialName: '79@10280_0',
        },
        {
          childName: '79_ceiling_light_frame_1_79@10280',
          materialName: '79@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '80@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '80',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '80_ceiling_light_emission_1_80@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '80_ceiling_light_frame_1_80@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '80_ceiling_light_emission_1_80@10280',
          materialName: '80@10280_0',
        },
        {
          childName: '80_ceiling_light_frame_1_80@10280',
          materialName: '80@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '81@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '81',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '81_ceiling_light_emission_1_81@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '81_ceiling_light_frame_1_81@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '81_ceiling_light_emission_1_81@10280',
          materialName: '81@10280_0',
        },
        {
          childName: '81_ceiling_light_frame_1_81@10280',
          materialName: '81@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '82@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '82',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '82_ceiling_light_emission_1_82@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '82_ceiling_light_frame_1_82@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '82_ceiling_light_emission_1_82@10280',
          materialName: '82@10280_0',
        },
        {
          childName: '82_ceiling_light_frame_1_82@10280',
          materialName: '82@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '83@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '83',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '83_ceiling_light_emission_1_83@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '83_ceiling_light_frame_1_83@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '83_ceiling_light_emission_1_83@10280',
          materialName: '83@10280_0',
        },
        {
          childName: '83_ceiling_light_frame_1_83@10280',
          materialName: '83@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '84@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '84',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '84_ceiling_light_emission_1_84@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '84_ceiling_light_frame_1_84@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '84_ceiling_light_emission_1_84@10280',
          materialName: '84@10280_0',
        },
        {
          childName: '84_ceiling_light_frame_1_84@10280',
          materialName: '84@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '85@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '85',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '85_ceiling_light_emission_1_85@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '85_ceiling_light_frame_1_85@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '85_ceiling_light_emission_1_85@10280',
          materialName: '85@10280_0',
        },
        {
          childName: '85_ceiling_light_frame_1_85@10280',
          materialName: '85@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '86@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '86',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '86_ceiling_light_emission_1_86@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '86_ceiling_light_frame_1_86@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '86_ceiling_light_emission_1_86@10280',
          materialName: '86@10280_0',
        },
        {
          childName: '86_ceiling_light_frame_1_86@10280',
          materialName: '86@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '87@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '87',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '87_ceiling_light_emission_1_87@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '87_ceiling_light_frame_1_87@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '87_ceiling_light_emission_1_87@10280',
          materialName: '87@10280_0',
        },
        {
          childName: '87_ceiling_light_frame_1_87@10280',
          materialName: '87@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '88@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '88',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '88_ceiling_light_emission_1_88@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '88_ceiling_light_frame_1_88@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '88_ceiling_light_emission_1_88@10280',
          materialName: '88@10280_0',
        },
        {
          childName: '88_ceiling_light_frame_1_88@10280',
          materialName: '88@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '89@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '89',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '89_ceiling_light_emission_1_89@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '89_ceiling_light_frame_1_89@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '89_ceiling_light_emission_1_89@10280',
          materialName: '89@10280_0',
        },
        {
          childName: '89_ceiling_light_frame_1_89@10280',
          materialName: '89@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '90@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '90',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '90_ceiling_light_emission_1_90@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '90_ceiling_light_frame_1_90@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '90_ceiling_light_emission_1_90@10280',
          materialName: '90@10280_0',
        },
        {
          childName: '90_ceiling_light_frame_1_90@10280',
          materialName: '90@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '91@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '91',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '91_ceiling_light_emission_1_91@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '91_ceiling_light_frame_1_91@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '91_ceiling_light_emission_1_91@10280',
          materialName: '91@10280_0',
        },
        {
          childName: '91_ceiling_light_frame_1_91@10280',
          materialName: '91@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '92@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '92',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '92_ceiling_light_emission_1_92@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '92_ceiling_light_frame_1_92@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '92_ceiling_light_emission_1_92@10280',
          materialName: '92@10280_0',
        },
        {
          childName: '92_ceiling_light_frame_1_92@10280',
          materialName: '92@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '93@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '93',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '93_ceiling_light_emission_1_93@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '93_ceiling_light_frame_1_93@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '93_ceiling_light_emission_1_93@10280',
          materialName: '93@10280_0',
        },
        {
          childName: '93_ceiling_light_frame_1_93@10280',
          materialName: '93@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '94@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '94',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '94_ceiling_light_emission_1_94@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '94_ceiling_light_frame_1_94@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '94_ceiling_light_emission_1_94@10280',
          materialName: '94@10280_0',
        },
        {
          childName: '94_ceiling_light_frame_1_94@10280',
          materialName: '94@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '95@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '95',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '95_ceiling_light_emission_1_95@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '95_ceiling_light_frame_1_95@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '95_ceiling_light_emission_1_95@10280',
          materialName: '95@10280_0',
        },
        {
          childName: '95_ceiling_light_frame_1_95@10280',
          materialName: '95@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '96@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '96',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '96_ceiling_light_emission_1_96@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '96_ceiling_light_frame_1_96@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '96_ceiling_light_emission_1_96@10280',
          materialName: '96@10280_0',
        },
        {
          childName: '96_ceiling_light_frame_1_96@10280',
          materialName: '96@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '97@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '97',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '97_ceiling_light_emission_1_97@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '97_ceiling_light_frame_1_97@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '97_ceiling_light_emission_1_97@10280',
          materialName: '97@10280_0',
        },
        {
          childName: '97_ceiling_light_frame_1_97@10280',
          materialName: '97@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '98@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '98',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '98_ceiling_light_emission_1_98@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '98_ceiling_light_frame_1_98@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '98_ceiling_light_emission_1_98@10280',
          materialName: '98@10280_0',
        },
        {
          childName: '98_ceiling_light_frame_1_98@10280',
          materialName: '98@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '99@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '99',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '99_ceiling_light_emission_1_99@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '99_ceiling_light_frame_1_99@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '99_ceiling_light_emission_1_99@10280',
          materialName: '99@10280_0',
        },
        {
          childName: '99_ceiling_light_frame_1_99@10280',
          materialName: '99@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Ceiling Light',
      objectName: '100@10280',
      blenderAssetbundleId: '10280',
      parentName: 'drs_ceiling_light',
      id: '10280',
      objectIndex: '100',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'ceiling_light_emission_1',
          childName: '100_ceiling_light_emission_1_100@10280',
        },
        {
          actualchildName: 'ceiling_light_frame_1',
          childName: '100_ceiling_light_frame_1_100@10280',
        },
      ],
      childrenMaterials: [
        {
          childName: '100_ceiling_light_emission_1_100@10280',
          materialName: '100@10280_0',
        },
        {
          childName: '100_ceiling_light_frame_1_100@10280',
          materialName: '100@10280_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv',
      objectName: '1@10285',
      blenderAssetbundleId: '10285',
      parentName: 'drs_tv',
      id: '10285',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel',
          childName: '1_tv_panel_1@10285',
        },
        {
          actualchildName: 'tvv_frame',
          childName: '1_tvv_frame_1@10285',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_1@10285',
          materialName: '1@10285_0',
        },
        {
          childName: '1_tvv_frame_1@10285',
          materialName: '1@10285_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 004',
      objectName: '1@10291',
      blenderAssetbundleId: '10291',
      parentName: 'drs_tv_004',
      id: '10291',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_004',
          childName: '1_tv_panel_004_1@10291',
        },
        {
          actualchildName: 'tvv_frame_004',
          childName: '1_tvv_frame_004_1@10291',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_004_1@10291',
          materialName: '1@10291_0',
        },
        {
          childName: '1_tvv_frame_004_1@10291',
          materialName: '1@10291_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 009',
      objectName: '1@10296',
      blenderAssetbundleId: '10296',
      parentName: 'drs_tv_009',
      id: '10296',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_009',
          childName: '1_tv_panel_009_1@10296',
        },
        {
          actualchildName: 'tvv_frame_009',
          childName: '1_tvv_frame_009_1@10296',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_009_1@10296',
          materialName: '1@10296_0',
        },
        {
          childName: '1_tvv_frame_009_1@10296',
          materialName: '1@10296_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Signage',
      objectName: '1@10284',
      blenderAssetbundleId: '10284',
      parentName: 'drs_signage',
      id: '10284',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'signage_base',
          childName: '1_signage_base_1@10284',
        },
        {
          actualchildName: 'signage_bidding',
          childName: '1_signage_bidding_1@10284',
        },
        {
          actualchildName: 'signage_front',
          childName: '1_signage_front_1@10284',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_signage_base_1@10284',
          materialName: '1@10284_0',
        },
        {
          childName: '1_signage_bidding_1@10284',
          materialName: '1@10284_1',
        },
        {
          childName: '1_signage_front_1@10284',
          materialName: '1@10284_2',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 002',
      objectName: '1@10289',
      blenderAssetbundleId: '10289',
      parentName: 'drs_tv_002',
      id: '10289',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_002',
          childName: '1_tv_panel_002_1@10289',
        },
        {
          actualchildName: 'tvv_frame_002',
          childName: '1_tvv_frame_002_1@10289',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_002_1@10289',
          materialName: '1@10289_0',
        },
        {
          childName: '1_tvv_frame_002_1@10289',
          materialName: '1@10289_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Door1',
      objectName: '1@10286',
      blenderAssetbundleId: '10286',
      parentName: 'drs_door1',
      id: '10286',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'door1_base',
          childName: '1_door1_base_1@10286',
        },
        {
          actualchildName: 'door1_handle',
          childName: '1_door1_handle_1@10286',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_door1_base_1@10286',
          materialName: '1@10286_0',
        },
        {
          childName: '1_door1_handle_1@10286',
          materialName: '1@10286_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 001',
      objectName: '1@10288',
      blenderAssetbundleId: '10288',
      parentName: 'drs_tv_001',
      id: '10288',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_001',
          childName: '1_tv_panel_001_1@10288',
        },
        {
          actualchildName: 'tvv_frame_001',
          childName: '1_tvv_frame_001_1@10288',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_001_1@10288',
          materialName: '1@10288_0',
        },
        {
          childName: '1_tvv_frame_001_1@10288',
          materialName: '1@10288_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 005',
      objectName: '1@10292',
      blenderAssetbundleId: '10292',
      parentName: 'drs_tv_005',
      id: '10292',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_005',
          childName: '1_tv_panel_005_1@10292',
        },
        {
          actualchildName: 'tvv_frame_005',
          childName: '1_tvv_frame_005_1@10292',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_005_1@10292',
          materialName: '1@10292_0',
        },
        {
          childName: '1_tvv_frame_005_1@10292',
          materialName: '1@10292_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 007',
      objectName: '1@10294',
      blenderAssetbundleId: '10294',
      parentName: 'drs_tv_007',
      id: '10294',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_007',
          childName: '1_tv_panel_007_1@10294',
        },
        {
          actualchildName: 'tvv_frame_007',
          childName: '1_tvv_frame_007_1@10294',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_007_1@10294',
          materialName: '1@10294_0',
        },
        {
          childName: '1_tvv_frame_007_1@10294',
          materialName: '1@10294_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Tv 003',
      objectName: '1@10290',
      blenderAssetbundleId: '10290',
      parentName: 'drs_tv_003',
      id: '10290',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'tv_panel_003',
          childName: '1_tv_panel_003_1@10290',
        },
        {
          actualchildName: 'tvv_frame_003',
          childName: '1_tvv_frame_003_1@10290',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_tv_panel_003_1@10290',
          materialName: '1@10290_0',
        },
        {
          childName: '1_tvv_frame_003_1@10290',
          materialName: '1@10290_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Mill Work',
      objectName: '1@10283',
      blenderAssetbundleId: '10283',
      parentName: 'drs_mill_work',
      id: '10283',
      objectIndex: '1',
      parentMat: '1@10283',
      childrenObjects: [],
      childrenMaterials: [],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Canon-PIXMA TR4720',
      objectName: '1@18959',
      blenderAssetbundleId: '18959',
      parentName: 'canon_pixma_tr4720',
      id: '18959',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'main_body',
          childName: '1_main_body_1@18959',
        },
        {
          actualchildName: 'printer_parts_1',
          childName: '1_printer_parts_1_1@18959',
        },
        {
          actualchildName: 'printer_parts_2',
          childName: '1_printer_parts_2_1@18959',
        },
        {
          actualchildName: 'printer_parts_3',
          childName: '1_printer_parts_3_1@18959',
        },
        {
          actualchildName: 'printer_parts_4',
          childName: '1_printer_parts_4_1@18959',
        },
        {
          actualchildName: 'printer_parts_6',
          childName: '1_printer_parts_6_1@18959',
        },
        {
          actualchildName: 'screen_buttons',
          childName: '1_screen_buttons_1@18959',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_main_body_1@18959',
          materialName: '1@18959_0',
        },
        {
          childName: '1_printer_parts_1_1@18959',
          materialName: '1@18959_1',
        },
        {
          childName: '1_printer_parts_2_1@18959',
          materialName: '1@18959_2',
        },
        {
          childName: '1_printer_parts_3_1@18959',
          materialName: '1@18959_3',
        },
        {
          childName: '1_printer_parts_4_1@18959',
          materialName: '1@18959_4',
        },
        {
          childName: '1_printer_parts_6_1@18959',
          materialName: '1@18959_5',
        },
        {
          childName: '1_screen_buttons_1@18959',
          materialName: '1@18959_6',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Counter',
      objectName: '1@10281',
      blenderAssetbundleId: '10281',
      parentName: 'drs_counter',
      id: '10281',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'counter_base',
          childName: '1_counter_base_1@10281',
        },
        {
          actualchildName: 'counter_top',
          childName: '1_counter_top_1@10281',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_counter_base_1@10281',
          materialName: '1@10281_0',
        },
        {
          childName: '1_counter_top_1@10281',
          materialName: '1@10281_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'The Dog Bed',
      objectName: '1@19984',
      blenderAssetbundleId: '19984',
      parentName: 'the_dog_bed',
      id: '19984',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'base',
          childName: '1_base_1@19984',
        },
        {
          actualchildName: 'fabric',
          childName: '1_fabric_1@19984',
        },
        {
          actualchildName: 'fabric2',
          childName: '1_fabric2_1@19984',
        },
        {
          actualchildName: 'stich1',
          childName: '1_stich1_1@19984',
        },
        {
          actualchildName: 'stich2',
          childName: '1_stich2_1@19984',
        },
        {
          actualchildName: 'tag',
          childName: '1_tag_1@19984',
        },
        {
          actualchildName: 'text',
          childName: '1_text_1@19984',
        },
        {
          actualchildName: 'text1',
          childName: '1_text1_1@19984',
        },
        {
          actualchildName: 'top',
          childName: '1_top_1@19984',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_base_1@19984',
          materialName: '1@19984_0',
        },
        {
          childName: '1_fabric2_1@19984',
          materialName: '1@19984_0',
        },
        {
          childName: '1_fabric_1@19984',
          materialName: '1@19984_1',
        },
        {
          childName: '1_top_1@19984',
          materialName: '1@19984_1',
        },
        {
          childName: '1_stich1_1@19984',
          materialName: '1@19984_2',
        },
        {
          childName: '1_stich2_1@19984',
          materialName: '1@19984_3',
        },
        {
          childName: '1_tag_1@19984',
          materialName: '1@19984_4',
        },
        {
          childName: '1_text_1@19984',
          materialName: '1@19984_5',
        },
        {
          childName: '1_text1_1@19984',
          materialName: '1@19984_5',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'The Dog Bed',
      objectName: '2@19984',
      blenderAssetbundleId: '19984',
      parentName: 'the_dog_bed',
      id: '19984',
      objectIndex: '2',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'base',
          childName: '2_base_2@19984',
        },
        {
          actualchildName: 'fabric',
          childName: '2_fabric_2@19984',
        },
        {
          actualchildName: 'fabric2',
          childName: '2_fabric2_2@19984',
        },
        {
          actualchildName: 'stich1',
          childName: '2_stich1_2@19984',
        },
        {
          actualchildName: 'stich2',
          childName: '2_stich2_2@19984',
        },
        {
          actualchildName: 'tag',
          childName: '2_tag_2@19984',
        },
        {
          actualchildName: 'text',
          childName: '2_text_2@19984',
        },
        {
          actualchildName: 'text1',
          childName: '2_text1_2@19984',
        },
        {
          actualchildName: 'top',
          childName: '2_top_2@19984',
        },
      ],
      childrenMaterials: [
        {
          childName: '2_base_2@19984',
          materialName: '2@19984_0',
        },
        {
          childName: '2_fabric2_2@19984',
          materialName: '2@19984_0',
        },
        {
          childName: '2_fabric_2@19984',
          materialName: '2@19984_1',
        },
        {
          childName: '2_top_2@19984',
          materialName: '2@19984_1',
        },
        {
          childName: '2_stich1_2@19984',
          materialName: '2@19984_2',
        },
        {
          childName: '2_stich2_2@19984',
          materialName: '2@19984_3',
        },
        {
          childName: '2_tag_2@19984',
          materialName: '2@19984_4',
        },
        {
          childName: '2_text_2@19984',
          materialName: '2@19984_5',
        },
        {
          childName: '2_text1_2@19984',
          materialName: '2@19984_5',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
    {
      assetBundleName: 'Drs Full Grid',
      objectName: '1@10282',
      blenderAssetbundleId: '10282',
      parentName: 'drs_full_grid',
      id: '10282',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'grid',
          childName: '1_grid_1@10282',
        },
        {
          actualchildName: 'hanger_wire',
          childName: '1_hanger_wire_1@10282',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_grid_1@10282',
          materialName: '1@10282_0',
        },
        {
          childName: '1_hanger_wire_1@10282',
          materialName: '1@10282_1',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
  ],
  blenderLayoutBundleDatas: [
    {
      assetBundleName: null,
      objectName: '1@547_layout',
      blenderAssetbundleId: '',
      parentName: 'dream_shop_layout',
      id: '547',
      objectIndex: '1',
      parentMat: null,
      childrenObjects: [
        {
          actualchildName: 'door_frame1',
          childName: '1_door_frame1_1@547_layout',
        },
        {
          actualchildName: 'floor',
          childName: '1_floor_1@547_layout',
        },
        {
          actualchildName: 'front_wall2',
          childName: '1_front_wall2_1@547_layout',
        },
        {
          actualchildName: 'front_wall2_2',
          childName: '1_front_wall2_2_1@547_layout',
        },
        {
          actualchildName: 'inner_back_wall1',
          childName: '1_inner_back_wall1_1@547_layout',
        },
        {
          actualchildName: 'inner_back_wall1_outer',
          childName: '1_inner_back_wall1_outer_1@547_layout',
        },
        {
          actualchildName: 'inner_big_back wall',
          childName: '1_inner_big_back wall_1@547_layout',
        },
        {
          actualchildName: 'inner_big_front wall',
          childName: '1_inner_big_front wall_1@547_layout',
        },
        {
          actualchildName: 'inner_big_left wall',
          childName: '1_inner_big_left wall_1@547_layout',
        },
        {
          actualchildName: 'inner_big_right wall',
          childName: '1_inner_big_right wall_1@547_layout',
        },
        {
          actualchildName: 'inner_entery_wall',
          childName: '1_inner_entery_wall_1@547_layout',
        },
        {
          actualchildName: 'inner_entery_wall_back',
          childName: '1_inner_entery_wall_back_1@547_layout',
        },
        {
          actualchildName: 'inner_entry_upper_wall',
          childName: '1_inner_entry_upper_wall_1@547_layout',
        },
        {
          actualchildName: 'inner_front_wall',
          childName: '1_inner_front_wall_1@547_layout',
        },
        {
          actualchildName: 'inner_front_wall 2',
          childName: '1_inner_front_wall 2_1@547_layout',
        },
        {
          actualchildName: 'inner_front_wall 2_back',
          childName: '1_inner_front_wall 2_back_1@547_layout',
        },
        {
          actualchildName: 'inner_front_wall_back',
          childName: '1_inner_front_wall_back_1@547_layout',
        },
        {
          actualchildName: 'inner_left_wall',
          childName: '1_inner_left_wall_1@547_layout',
        },
        {
          actualchildName: 'inner_left_wall_back',
          childName: '1_inner_left_wall_back_1@547_layout',
        },
        {
          actualchildName: 'inner_right_wall',
          childName: '1_inner_right_wall_1@547_layout',
        },
        {
          actualchildName: 'inner_right_wall_back',
          childName: '1_inner_right_wall_back_1@547_layout',
        },
        {
          actualchildName: 'inner_store_wall',
          childName: '1_inner_store_wall_1@547_layout',
        },
        {
          actualchildName: 'outer_wall',
          childName: '1_outer_wall_1@547_layout',
        },
        {
          actualchildName: 'right_wall2',
          childName: '1_right_wall2_1@547_layout',
        },
        {
          actualchildName: 'roof',
          childName: '1_roof_1@547_layout',
        },
        {
          actualchildName: 'store_inner_wall',
          childName: '1_store_inner_wall_1@547_layout',
        },
      ],
      childrenMaterials: [
        {
          childName: '1_door_frame1_1@547_layout',
          materialName: '1@547_layout_0',
        },
        {
          childName: '1_floor_1@547_layout',
          materialName: '1@547_layout_1',
        },
        {
          childName: '1_front_wall2_1@547_layout',
          materialName: '1@547_layout_2',
        },
        {
          childName: '1_front_wall2_2_1@547_layout',
          materialName: '1@547_layout_3',
        },
        {
          childName: '1_inner_back_wall1_1@547_layout',
          materialName: '1@547_layout_4',
        },
        {
          childName: '1_inner_back_wall1_outer_1@547_layout',
          materialName: '1@547_layout_5',
        },
        {
          childName: '1_inner_big_back wall_1@547_layout',
          materialName: '1@547_layout_6',
        },
        {
          childName: '1_inner_big_front wall_1@547_layout',
          materialName: '1@547_layout_7',
        },
        {
          childName: '1_inner_big_left wall_1@547_layout',
          materialName: '1@547_layout_7',
        },
        {
          childName: '1_inner_big_right wall_1@547_layout',
          materialName: '1@547_layout_8',
        },
        {
          childName: '1_inner_entery_wall_1@547_layout',
          materialName: '1@547_layout_9',
        },
        {
          childName: '1_inner_entery_wall_back_1@547_layout',
          materialName: '1@547_layout_10',
        },
        {
          childName: '1_inner_entry_upper_wall_1@547_layout',
          materialName: '1@547_layout_11',
        },
        {
          childName: '1_inner_front_wall_1@547_layout',
          materialName: '1@547_layout_12',
        },
        {
          childName: '1_inner_front_wall 2_1@547_layout',
          materialName: '1@547_layout_13',
        },
        {
          childName: '1_inner_front_wall 2_back_1@547_layout',
          materialName: '1@547_layout_14',
        },
        {
          childName: '1_inner_front_wall_back_1@547_layout',
          materialName: '1@547_layout_15',
        },
        {
          childName: '1_inner_left_wall_1@547_layout',
          materialName: '1@547_layout_16',
        },
        {
          childName: '1_inner_left_wall_back_1@547_layout',
          materialName: '1@547_layout_17',
        },
        {
          childName: '1_inner_right_wall_1@547_layout',
          materialName: '1@547_layout_18',
        },
        {
          childName: '1_inner_right_wall_back_1@547_layout',
          materialName: '1@547_layout_19',
        },
        {
          childName: '1_inner_store_wall_1@547_layout',
          materialName: '1@547_layout_20',
        },
        {
          childName: '1_outer_wall_1@547_layout',
          materialName: '1@547_layout_21',
        },
        {
          childName: '1_right_wall2_1@547_layout',
          materialName: '1@547_layout_22',
        },
        {
          childName: '1_roof_1@547_layout',
          materialName: '1@547_layout_23',
        },
        {
          childName: '1_store_inner_wall_1@547_layout',
          materialName: '1@547_layout_24',
        },
      ],
      isDuplicateProp: false,
      isWindowAndDoor: false,
      loadedPropType: 'None',
      modelType: 'None',
    },
  ],
  roomMetadata: {},
  culpSkuUsedData: {},
  backgrounds: [],
  automationData: {},
  groupPropsMapping: {},
  transformChangedObjectData: {
    '1@547_layout': {
      objectName: '1@547_layout',
      xPosition: 0,
      yPosition: 0,
      zPosition: 0,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10295': {
      objectName: '1@10295',
      xPosition: 7.15078259,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10293': {
      objectName: '1@10293',
      xPosition: 3.41819286,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10280': {
      objectName: '1@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '2@10280': {
      objectName: '2@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '3@10280': {
      objectName: '3@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '4@10280': {
      objectName: '4@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '5@10280': {
      objectName: '5@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '6@10280': {
      objectName: '6@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: -5.78896952,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '7@10280': {
      objectName: '7@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: -2.13136959,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '8@10280': {
      objectName: '8@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: 1.52623034,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '9@10280': {
      objectName: '9@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: 5.18383026,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '10@10280': {
      objectName: '10@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '11@10280': {
      objectName: '11@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '12@10280': {
      objectName: '12@10280',
      xPosition: -12.4961872,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '13@10280': {
      objectName: '13@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '14@10280': {
      objectName: '14@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '15@10280': {
      objectName: '15@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '16@10280': {
      objectName: '16@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '17@10280': {
      objectName: '17@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: 5.18383074,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '18@10280': {
      objectName: '18@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: 1.52623081,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '19@10280': {
      objectName: '19@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: -2.131369,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '20@10280': {
      objectName: '20@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: -5.788969,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '21@10280': {
      objectName: '21@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '22@10280': {
      objectName: '22@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '23@10280': {
      objectName: '23@10280',
      xPosition: -8.838587,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '24@10280': {
      objectName: '24@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: 5.18383074,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '25@10280': {
      objectName: '25@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '26@10280': {
      objectName: '26@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '27@10280': {
      objectName: '27@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '28@10280': {
      objectName: '28@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: -5.78896952,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '29@10280': {
      objectName: '29@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: -2.13136959,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '30@10280': {
      objectName: '30@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: 1.52623034,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '31@10280': {
      objectName: '31@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: 5.18383026,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '32@10280': {
      objectName: '32@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '33@10280': {
      objectName: '33@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '34@10280': {
      objectName: '34@10280',
      xPosition: -5.180987,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '35@10280': {
      objectName: '35@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: 1.52623081,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '36@10280': {
      objectName: '36@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '37@10280': {
      objectName: '37@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '38@10280': {
      objectName: '38@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '39@10280': {
      objectName: '39@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: 5.18383074,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '40@10280': {
      objectName: '40@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: 1.52623081,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '41@10280': {
      objectName: '41@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: -2.131369,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '42@10280': {
      objectName: '42@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: -5.788969,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '43@10280': {
      objectName: '43@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '44@10280': {
      objectName: '44@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '45@10280': {
      objectName: '45@10280',
      xPosition: -1.523387,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '46@10280': {
      objectName: '46@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: -2.131369,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '47@10280': {
      objectName: '47@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '48@10280': {
      objectName: '48@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '49@10280': {
      objectName: '49@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '50@10280': {
      objectName: '50@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: -5.78896952,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '51@10280': {
      objectName: '51@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: -2.13136959,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '52@10280': {
      objectName: '52@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: 1.52623034,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '53@10280': {
      objectName: '53@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: 5.18383026,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '54@10280': {
      objectName: '54@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '55@10280': {
      objectName: '55@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '56@10280': {
      objectName: '56@10280',
      xPosition: 2.134213,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '57@10280': {
      objectName: '57@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: -5.788969,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '58@10280': {
      objectName: '58@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '59@10280': {
      objectName: '59@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '60@10280': {
      objectName: '60@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '61@10280': {
      objectName: '61@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: 5.18383074,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '62@10280': {
      objectName: '62@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: 1.52623081,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '63@10280': {
      objectName: '63@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: -2.131369,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '64@10280': {
      objectName: '64@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: -5.788969,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '65@10280': {
      objectName: '65@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '66@10280': {
      objectName: '66@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '67@10280': {
      objectName: '67@10280',
      xPosition: 5.791813,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '68@10280': {
      objectName: '68@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '69@10280': {
      objectName: '69@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '70@10280': {
      objectName: '70@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '71@10280': {
      objectName: '71@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '72@10280': {
      objectName: '72@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: -5.78896952,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '73@10280': {
      objectName: '73@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: -2.13136959,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '74@10280': {
      objectName: '74@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: 1.52623034,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '75@10280': {
      objectName: '75@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: 5.18383026,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '76@10280': {
      objectName: '76@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '77@10280': {
      objectName: '77@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '78@10280': {
      objectName: '78@10280',
      xPosition: 9.449413,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '79@10280': {
      objectName: '79@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '80@10280': {
      objectName: '80@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '81@10280': {
      objectName: '81@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '82@10280': {
      objectName: '82@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '83@10280': {
      objectName: '83@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: 5.18383074,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '84@10280': {
      objectName: '84@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: 1.52623081,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '85@10280': {
      objectName: '85@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: -2.131369,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '86@10280': {
      objectName: '86@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: -5.788969,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '87@10280': {
      objectName: '87@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '88@10280': {
      objectName: '88@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '89@10280': {
      objectName: '89@10280',
      xPosition: 13.1070137,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '90@10280': {
      objectName: '90@10280',
      xPosition: -16.1537876,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '91@10280': {
      objectName: '91@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: -16.76177,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '92@10280': {
      objectName: '92@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: -13.10417,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '93@10280': {
      objectName: '93@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: -9.446569,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '94@10280': {
      objectName: '94@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: -5.78896952,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '95@10280': {
      objectName: '95@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: -2.13136959,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '96@10280': {
      objectName: '96@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: 1.52623034,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '97@10280': {
      objectName: '97@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: 5.18383026,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '98@10280': {
      objectName: '98@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: 8.841431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '99@10280': {
      objectName: '99@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: 12.4990311,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '100@10280': {
      objectName: '100@10280',
      xPosition: 16.7646141,
      yPosition: 6.096973,
      zPosition: 16.1566315,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10285': {
      objectName: '1@10285',
      xPosition: -7.77981663,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10291': {
      objectName: '1@10291',
      xPosition: -0.312429428,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10296': {
      objectName: '1@10296',
      xPosition: 9.015629,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10284': {
      objectName: '1@10284',
      xPosition: 0,
      yPosition: 3.04800415,
      zPosition: 5.953136,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10289': {
      objectName: '1@10289',
      xPosition: -4.04919434,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10286': {
      objectName: '1@10286',
      xPosition: -9.816196,
      yPosition: 0,
      zPosition: -9.526363,
      xRotation: 0,
      yRotation: 8.742278e-8,
      zRotation: 0,
      wRotation: -1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10288': {
      objectName: '1@10288',
      xPosition: -5.914971,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10292': {
      objectName: '1@10292',
      xPosition: 1.55241632,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10294': {
      objectName: '1@10294',
      xPosition: 5.28303862,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10290': {
      objectName: '1@10290',
      xPosition: -2.18434858,
      yPosition: 1.65452182,
      zPosition: -11.75827,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10283': {
      objectName: '1@10283',
      xPosition: -10.9016809,
      yPosition: 0,
      zPosition: -0.494975656,
      xRotation: 0,
      yRotation: 0.707106769,
      zRotation: 0,
      wRotation: 0.7071068,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@18959': {
      objectName: '1@18959',
      xPosition: -10.3069,
      yPosition: 0,
      zPosition: 7.605971,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10281': {
      objectName: '1@10281',
      xPosition: 5.895631,
      yPosition: 0,
      zPosition: 4.49454069,
      xRotation: 0,
      yRotation: -0.707106769,
      zRotation: 0,
      wRotation: 0.7071068,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@19984': {
      objectName: '1@19984',
      xPosition: -17.8426228,
      yPosition: 0,
      zPosition: 19.1691513,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '2@19984': {
      objectName: '2@19984',
      xPosition: -9.18245,
      yPosition: 0.000005751848,
      zPosition: 8.847557,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    '1@10282': {
      objectName: '1@10282',
      xPosition: -0.609981537,
      yPosition: 6.095744,
      zPosition: 0.00384902954,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light1: {
      objectName: 'Light1',
      xPosition: 15.8532515,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light2: {
      objectName: 'Light2',
      xPosition: 10.6394262,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light3: {
      objectName: 'Light3',
      xPosition: 5.425601,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light4: {
      objectName: 'Light4',
      xPosition: 0.211776018,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light5: {
      objectName: 'Light5',
      xPosition: -5.00204945,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light6: {
      objectName: 'Light6',
      xPosition: -10.2158747,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light7: {
      objectName: 'Light7',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: 14.3200216,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light8: {
      objectName: 'Light8',
      xPosition: 14.8355,
      yPosition: 5.30326653,
      zPosition: -14.54442,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light9: {
      objectName: 'Light9',
      xPosition: 10.6394262,
      yPosition: 5.30326653,
      zPosition: -14.9691248,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light10: {
      objectName: 'Light10',
      xPosition: 5.425601,
      yPosition: 5.30326653,
      zPosition: -14.9691248,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light11: {
      objectName: 'Light11',
      xPosition: 0.211776018,
      yPosition: 5.30326653,
      zPosition: -14.9691248,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light12: {
      objectName: 'Light12',
      xPosition: -5.00204945,
      yPosition: 5.30326653,
      zPosition: -14.9691248,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light13: {
      objectName: 'Light13',
      xPosition: 9.410282,
      yPosition: 5.30326653,
      zPosition: 1.51417208,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light14: {
      objectName: 'Light14',
      xPosition: 9.410282,
      yPosition: 5.30326653,
      zPosition: -2.1470418,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light15: {
      objectName: 'Light15',
      xPosition: -10.2158747,
      yPosition: 5.30326653,
      zPosition: -14.9691248,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light16: {
      objectName: 'Light16',
      xPosition: 9.425522,
      yPosition: 5.30326653,
      zPosition: -5.812806,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light17: {
      objectName: 'Light17',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: -14.5267906,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light18: {
      objectName: 'Light18',
      xPosition: 9.427062,
      yPosition: 5.30326653,
      zPosition: -9.44529152,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light19: {
      objectName: 'Light19',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: -8.529396,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light20: {
      objectName: 'Light20',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: -2.51437187,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light21: {
      objectName: 'Light21',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: 3.50065231,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light22: {
      objectName: 'Light22',
      xPosition: -14.5354166,
      yPosition: 5.30326653,
      zPosition: 9.5156765,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light23: {
      objectName: 'Light23',
      xPosition: 7.914651,
      yPosition: 5.30326653,
      zPosition: 8.050174,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light24: {
      objectName: 'Light24',
      xPosition: 14.8113489,
      yPosition: 5.30326653,
      zPosition: -8.529396,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light25: {
      objectName: 'Light25',
      xPosition: 14.8113489,
      yPosition: 5.30326653,
      zPosition: -2.51437187,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light26: {
      objectName: 'Light26',
      xPosition: 5.766903,
      yPosition: 5.30326653,
      zPosition: 1.51240563,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light27: {
      objectName: 'Light27',
      xPosition: 5.766903,
      yPosition: 5.30326653,
      zPosition: -2.14880824,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light28: {
      objectName: 'Light28',
      xPosition: 14.8113489,
      yPosition: 5.30326653,
      zPosition: 3.50065231,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light29: {
      objectName: 'Light29',
      xPosition: 5.77347374,
      yPosition: 5.30326653,
      zPosition: -5.806701,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light30: {
      objectName: 'Light30',
      xPosition: 5.767786,
      yPosition: 5.30326653,
      zPosition: -9.444408,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light31: {
      objectName: 'Light31',
      xPosition: 4.258024,
      yPosition: 5.30326653,
      zPosition: 8.050174,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light32: {
      objectName: 'Light32',
      xPosition: 2.09702873,
      yPosition: 5.30326653,
      zPosition: 1.518588,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light33: {
      objectName: 'Light33',
      xPosition: 2.09702873,
      yPosition: 5.30326653,
      zPosition: -2.14262581,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light34: {
      objectName: 'Light34',
      xPosition: 2.11074281,
      yPosition: 5.30326653,
      zPosition: -5.79754448,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light35: {
      objectName: 'Light35',
      xPosition: 2.13147235,
      yPosition: 5.30326653,
      zPosition: -9.453239,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light36: {
      objectName: 'Light36',
      xPosition: 0.601397157,
      yPosition: 5.30326653,
      zPosition: 8.050174,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light37: {
      objectName: 'Light37',
      xPosition: -1.52603745,
      yPosition: 5.30326653,
      zPosition: 1.5150553,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light38: {
      objectName: 'Light38',
      xPosition: -1.52603745,
      yPosition: 5.30326653,
      zPosition: -2.1461587,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light39: {
      objectName: 'Light39',
      xPosition: -1.5443579,
      yPosition: 5.30326653,
      zPosition: -5.7960186,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light40: {
      objectName: 'Light40',
      xPosition: -1.53133655,
      yPosition: 5.30326653,
      zPosition: -9.453239,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light41: {
      objectName: 'Light41',
      xPosition: -3.05522943,
      yPosition: 5.30326653,
      zPosition: 8.050174,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light42: {
      objectName: 'Light42',
      xPosition: -5.181781,
      yPosition: 5.30326653,
      zPosition: 1.52741957,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light43: {
      objectName: 'Light43',
      xPosition: -5.181781,
      yPosition: 5.30326653,
      zPosition: -2.13379431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light44: {
      objectName: 'Light44',
      xPosition: -5.192379,
      yPosition: 5.30326653,
      zPosition: -5.793687,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light45: {
      objectName: 'Light45',
      xPosition: -5.16853333,
      yPosition: 5.30326653,
      zPosition: -9.460305,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light46: {
      objectName: 'Light46',
      xPosition: -6.711856,
      yPosition: 5.30326653,
      zPosition: 8.050174,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light47: {
      objectName: 'Light47',
      xPosition: -8.832226,
      yPosition: 5.30326653,
      zPosition: 1.51240563,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light48: {
      objectName: 'Light48',
      xPosition: -8.832226,
      yPosition: 5.30326653,
      zPosition: -2.14880824,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light49: {
      objectName: 'Light49',
      xPosition: -8.82887,
      yPosition: 5.30326653,
      zPosition: -5.771431,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
    Light50: {
      objectName: 'Light50',
      xPosition: -8.837524,
      yPosition: 5.30326653,
      zPosition: -9.454123,
      xRotation: 0,
      yRotation: 0,
      zRotation: 0,
      wRotation: 1,
      xScale: 0.1,
      yScale: 0.1,
      zScale: 0.1,
      isScaled: false,
      centerPivotPositionX: 0,
      centerPivotPositionY: 0,
      centerPivotPositionZ: 0,
    },
  },
  deletedObjectData: [],
  roomLightData: [
    {
      id: '1',
      lightName: 'SceneLight 1',
      lightPrefabName: 'Light1',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '2',
      lightName: 'SceneLight 2',
      lightPrefabName: 'Light2',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '3',
      lightName: 'SceneLight 3',
      lightPrefabName: 'Light3',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '4',
      lightName: 'SceneLight 4',
      lightPrefabName: 'Light4',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '5',
      lightName: 'SceneLight 5',
      lightPrefabName: 'Light5',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '6',
      lightName: 'SceneLight 6',
      lightPrefabName: 'Light6',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '7',
      lightName: 'SceneLight 7',
      lightPrefabName: 'Light7',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '8',
      lightName: 'SceneLight 8',
      lightPrefabName: 'Light8',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '9',
      lightName: 'SceneLight 9',
      lightPrefabName: 'Light9',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '10',
      lightName: 'SceneLight 10',
      lightPrefabName: 'Light10',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '11',
      lightName: 'SceneLight 11',
      lightPrefabName: 'Light11',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '12',
      lightName: 'SceneLight 12',
      lightPrefabName: 'Light12',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '13',
      lightName: 'SceneLight 13',
      lightPrefabName: 'Light13',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '14',
      lightName: 'SceneLight 14',
      lightPrefabName: 'Light14',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '15',
      lightName: 'SceneLight 15',
      lightPrefabName: 'Light15',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '16',
      lightName: 'SceneLight 16',
      lightPrefabName: 'Light16',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '17',
      lightName: 'SceneLight 17',
      lightPrefabName: 'Light17',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '18',
      lightName: 'SceneLight 18',
      lightPrefabName: 'Light18',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '19',
      lightName: 'SceneLight 19',
      lightPrefabName: 'Light19',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '20',
      lightName: 'SceneLight 20',
      lightPrefabName: 'Light20',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '21',
      lightName: 'SceneLight 21',
      lightPrefabName: 'Light21',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '22',
      lightName: 'SceneLight 22',
      lightPrefabName: 'Light22',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '23',
      lightName: 'SceneLight 23',
      lightPrefabName: 'Light23',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '24',
      lightName: 'SceneLight 24',
      lightPrefabName: 'Light24',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '25',
      lightName: 'SceneLight 25',
      lightPrefabName: 'Light25',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '26',
      lightName: 'SceneLight 26',
      lightPrefabName: 'Light26',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '27',
      lightName: 'SceneLight 27',
      lightPrefabName: 'Light27',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '28',
      lightName: 'SceneLight 28',
      lightPrefabName: 'Light28',
      lightType: 'Area',
      lightDetails: {
        Point: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0762,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 25,
          size: 1.52,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 1.52,
      sizeHeight: 1.52,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '29',
      lightName: 'SceneLight 29',
      lightPrefabName: 'Light29',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '30',
      lightName: 'SceneLight 30',
      lightPrefabName: 'Light30',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '31',
      lightName: 'SceneLight 31',
      lightPrefabName: 'Light31',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '32',
      lightName: 'SceneLight 32',
      lightPrefabName: 'Light32',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '33',
      lightName: 'SceneLight 33',
      lightPrefabName: 'Light33',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '34',
      lightName: 'SceneLight 34',
      lightPrefabName: 'Light34',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '35',
      lightName: 'SceneLight 35',
      lightPrefabName: 'Light35',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '36',
      lightName: 'SceneLight 36',
      lightPrefabName: 'Light36',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '37',
      lightName: 'SceneLight 37',
      lightPrefabName: 'Light37',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '38',
      lightName: 'SceneLight 38',
      lightPrefabName: 'Light38',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '39',
      lightName: 'SceneLight 39',
      lightPrefabName: 'Light39',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '40',
      lightName: 'SceneLight 40',
      lightPrefabName: 'Light40',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '41',
      lightName: 'SceneLight 41',
      lightPrefabName: 'Light41',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '42',
      lightName: 'SceneLight 42',
      lightPrefabName: 'Light42',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '43',
      lightName: 'SceneLight 43',
      lightPrefabName: 'Light43',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '44',
      lightName: 'SceneLight 44',
      lightPrefabName: 'Light44',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '45',
      lightName: 'SceneLight 45',
      lightPrefabName: 'Light45',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '46',
      lightName: 'SceneLight 46',
      lightPrefabName: 'Light46',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '47',
      lightName: 'SceneLight 47',
      lightPrefabName: 'Light47',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '48',
      lightName: 'SceneLight 48',
      lightPrefabName: 'Light48',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '49',
      lightName: 'SceneLight 49',
      lightPrefabName: 'Light49',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
    {
      id: '50',
      lightName: 'SceneLight 50',
      lightPrefabName: 'Light50',
      lightType: 'Point',
      lightDetails: {
        Point: {
          lightColor: '#FFFAF4',
          intensity: 0.8,
          size: 0.508,
        },
        Spot: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.0254,
        },
        Area: {
          lightColor: '#FFFFFF',
          intensity: 14,
          size: 0.2,
        },
        Direction: {
          lightColor: '#FFFFFF',
          intensity: 1,
          size: 1,
        },
      },
      sizeWidth: 0.3,
      sizeHeight: 0.3,
      spotAngle: 30,
      blendSpot: 1,
      visibleInReflection: true,
      visibleInGlass: true,
      visibleInDiffuse: true,
      visibleInGlossyMaterials: false,
      enableInRendering: true,
      is_portal: false,
      xScale: 1,
      yScale: 1,
      zScale: 1,
      type: 'Room',
      parentName: null,
      blenderName: null,
      disableLightForConfigurator: false,
      isConfiguratorLight: false,
      isLightDeleted: false,
    },
  ],
  roomCameraInfo: {
    distanceToSet: 3.5,
    fov: 40,
    xTransRot: 89.98022,
    yTransRot: 180,
    zTransRot: 0,
    wTransRot: 0,
    centerObjectxPos: 0,
    centerObjectyPos: 2.94813323,
    centerObjectzPos: 0,
    isCameraCorrection: false,
    lensShiftY: 0,
    cameraHeight: null,
    cameraRotX: 0,
    cameraRotZ: 0,
    focalLength: 15.4545612,
    isdepthOfField: false,
    selectedObjectName: null,
    blurIntensity: 0,
    xPos: -4.37099565e-8,
    yPos: 102.948128,
    zPos: -0.4999642,
    cameraName: null,
    resoX: 0,
    resoY: 0,
    sensor_width: 20,
    sensor_height: 11.25,
    horizontalFov: 0,
  },
  materialDetails: [],
  screenWidth: 1344,
  screenHeight: 732,
  cameraAspect: 1.8360655737704918,
  propsHierarchyData: {},
  materialVersion: 'V3',
  duplicatePropDatas: [],
  cutOutPropData: {},
  transparentObjectNames: [],
  outerWallName: null,
  SelectedEnvironmentLight: {
    isAO: false,
    color: {
      isEnvironmentColorEnabled: true,
      actualIntensity: 1,
      environmentColor: '#FFFFFF',
      environmentIntensity: 1.2,
    },
    hdri: {
      ishdriEnabled: false,
      hdriRotation: 0,
      hdriIntensity: 1,
      hdriId: 122,
      hdriName: 'Reichstag 1',
      isIntensityChanged: false,
      isRotationChanged: false,
      isHDRIChanged: false,
    },
  },
  environmentLightWasChanged: true,
  cameraList: [
    {
      id: '0e17dcc6-b4f9-4958-8879-822b84b6ad2b',
      cameraName: 'hotspot2-cam2',
      distanceToSet: 1.5615,
      fov: 40,
      horizontalFov: '0.00000000000000',
      xTransRot: 28.14,
      yTransRot: 184.4341,
      zTransRot: 0,
      centerObjectxPos: -10.3069,
      centerObjectyPos: -0.0049,
      centerObjectzPos: 7.7546,
      isCameraCorrection: false,
      lensShiftY: 0,
      cameraHeight: 0.73,
      cameraRotX: 0,
      cameraRotZ: 0,
      focalLength: 15.4546,
      isdepthOfField: false,
      selectedObjectName: '',
      blurIntensity: 5,
      resoX: 1500,
      resoY: 843,
      xPos: -10.2004,
      zPos: 9.1274,
      yPos: 0.7315,
      isPredefinedCamera: false,
      is_rendered: false,
      focusXPos: null,
      focusYPos: null,
      focusZPos: null,
      canvas_width: 1344,
      canvas_height: 732,
      sensor_width: 20,
      sensor_height: 11.25,
      fov_axis: 'Vertical',
      gate_fit: 'Overscan',
      dpi: 72,
      tags: ['tag4'],
      sequence_number: 1,
    },
    {
      id: '4ea34c26-4dad-439a-b472-a71ab271e003',
      cameraName: 'hotspot2-cam1',
      distanceToSet: 1.5615,
      fov: 40,
      horizontalFov: '0.00000000000000',
      xTransRot: 30.66,
      yTransRot: 119.9341,
      zTransRot: 0,
      centerObjectxPos: -10.3069,
      centerObjectyPos: -0.0049,
      centerObjectzPos: 7.7546,
      isCameraCorrection: false,
      lensShiftY: 0,
      cameraHeight: 0.79,
      cameraRotX: 0,
      cameraRotZ: 0,
      focalLength: 15.4546,
      isdepthOfField: false,
      selectedObjectName: '',
      blurIntensity: 5,
      resoX: 1500,
      resoY: 843,
      xPos: -11.471,
      zPos: 8.4249,
      yPos: 0.7914,
      isPredefinedCamera: false,
      is_rendered: false,
      focusXPos: null,
      focusYPos: null,
      focusZPos: null,
      canvas_width: 1344,
      canvas_height: 732,
      sensor_width: 20,
      sensor_height: 11.25,
      fov_axis: 'Vertical',
      gate_fit: 'Overscan',
      dpi: 72,
      tags: ['0_Straight'],
      sequence_number: 2,
    },
    {
      id: 'ca561679-6098-4f3d-bc49-6db76f110361',
      cameraName: 'hotspot1-cam2',
      distanceToSet: 2.066,
      fov: 40,
      horizontalFov: '0.00000000000000',
      xTransRot: 23.88,
      yTransRot: 200.934,
      zTransRot: 0,
      centerObjectxPos: -8.9611,
      centerObjectyPos: -0.0312,
      centerObjectzPos: 8.779,
      isCameraCorrection: false,
      lensShiftY: 0,
      cameraHeight: 0.81,
      cameraRotX: 0,
      cameraRotZ: 0,
      focalLength: 15.4546,
      isdepthOfField: false,
      selectedObjectName: '',
      blurIntensity: 5,
      resoX: 1500,
      resoY: 843,
      xPos: -8.2861,
      zPos: 10.5434,
      yPos: 0.8051,
      isPredefinedCamera: false,
      is_rendered: false,
      focusXPos: null,
      focusYPos: null,
      focusZPos: null,
      canvas_width: 1344,
      canvas_height: 732,
      sensor_width: 20,
      sensor_height: 11.25,
      fov_axis: 'Vertical',
      gate_fit: 'Overscan',
      dpi: 72,
      tags: ['0_Straight'],
      sequence_number: 3,
    },
    {
      id: 'b7ccf7b2-e12c-4929-b155-b25d4ef6e051',
      cameraName: 'hotspot1-cam1',
      distanceToSet: 2.2375,
      fov: 40,
      horizontalFov: '0.00000000000000',
      xTransRot: 23.28,
      yTransRot: 125.514,
      zTransRot: 0,
      centerObjectxPos: -9.1802,
      centerObjectyPos: -0.0017,
      centerObjectzPos: 8.8489,
      isCameraCorrection: false,
      lensShiftY: 0,
      cameraHeight: 0.88,
      cameraRotX: 0,
      cameraRotZ: 0,
      focalLength: 15.4546,
      isdepthOfField: false,
      selectedObjectName: '',
      blurIntensity: 5,
      resoX: 1500,
      resoY: 843,
      xPos: -10.8532,
      zPos: 10.0428,
      yPos: 0.8826,
      isPredefinedCamera: false,
      is_rendered: false,
      focusXPos: null,
      focusYPos: null,
      focusZPos: null,
      canvas_width: 1344,
      canvas_height: 732,
      sensor_width: 20,
      sensor_height: 11.25,
      fov_axis: 'Vertical',
      gate_fit: 'Overscan',
      dpi: 72,
      tags: ['0_Straight'],
      sequence_number: 4,
    },
  ],
  roomId: 857,
  baseRoomId: 857,
  infoData: {
    userId: 10505,
  },
  hotspot: [
    {
      linked_product_blender_id: 19984,
      cameraInfo: [
        {
          thumbnail_link:
            'https://media-stag.imagine.io/media/public/retail_static/HotspotThumb_hotspot1-cam1_filmic.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEA4aCXVzLWVhc3QtMSJIMEYCIQCdejv7ap1%2FPZtm9rDdAhwA8sdaKHPxS%2FY4wX8f5tGcpgIhAPr7%2F1MxJN1cC4uJWrDF1EaOLktryneLyOgwJRTufRzyKvsCCCcQARoMNDg5OTEwNzg0NjY2IgwZZrA5XlTOsRC7j8Iq2AIU3IcQcUmtkZpmZ%2Bbykxy73jWCt1vfEkNw5KlM9PA4cEWjQpRU91gNXcDBcYTZTSZ%2BFuOEJYrO2TUBNHP91r0fCyLUQIhAjz25PBi0hkLre5USOUkLhXJU4sxVLAvVQvaGHgqW4fQ7caZf%2FwLQ7KtcbnSmbt2rBIEaH5xHeCDyAS6py19bQJoKxPjSxWnqnNxTJy1NtWFZQRzgVr0lSnZ%2FXpDwVL7X4V7HfMcLk8W8jSZZalYsdUH%2BdJoaLfjxOO1Uwbs2AWgVYO37DFrb%2F3ySXDN545Qat3WFdgBueffRFP8EHbCjE3yV88Ime1FbemcpAHJCKPvb5F9u7Cn2VG1qDFbuNnoJ1%2BxRimqbtzLG82bgCZG4CzSRrun02imibhYV5Uiob7ZHp5tzt1kV3h4SE5puAOL9wuaxNoIyjbKAxsbR3kZbFAUaGUWI8omSUcGa3tXc9lmuaDCm6rq2BjqyAr39mb%2Folc4rrcH9NEY3lM9%2BVAX57%2BiRPrzenVzLZ6m4OL5%2BrWmuKTNFf5%2B1%2FCh%2FMEBRqoGZVmQ01N1IQQw37rERe2EfKkE1GcB6oMrzkaeg31Mq2bRCCGXK8tKvpFcm%2BA%2FLcQbuCvOuDdjxfR%2BhbeVSSSMqoV1Yf7gb%2FFBhmdE%2B1wtQxsU6BmJiL3aWetdLAEn9oHxDtH%2F%2Bc2eC6grmIPKYDBTkUdUGHVBtQgAt5IhHbGHKsiWwTL6ztu13tm3Cx%2BbLwnJIbtnBHd%2FnX0H6Lv%2FWtYOeET7drbKZEHMF2%2FwjrxY%2BTSr69Qy6RbwksK8w9pexeo0ybrSfplSqAqq1upoeHR9I3o3ytBG%2FKtv2Bcuu8xLtP6ADo9sPeZjrcXwucgSa5y9fujffNThG2LRqLrzuaQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240828T080932Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIAXEEHVKKNEQPRQXC2%2F20240828%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=2a406f393785bc2fbb85f199bee0a45352c5a805862e4afc3fa915f3ea17ea44',
          id: 'b7ccf7b2-e12c-4929-b155-b25d4ef6e051',
          cameraName: 'hotspot1-cam1',
          distanceToSet: 2.2375,
          fov: 40,
          horizontalFov: '0.00000000000000',
          xTransRot: 23.28,
          yTransRot: 125.514,
          zTransRot: 0,
          centerObjectxPos: -9.1802,
          centerObjectyPos: -0.0017,
          centerObjectzPos: 8.8489,
          isCameraCorrection: false,
          lensShiftY: 0,
          cameraHeight: 0.88,
          cameraRotX: 0,
          cameraRotZ: 0,
          focalLength: 15.4546,
          isdepthOfField: false,
          selectedObjectName: '',
          blurIntensity: 5,
          resoX: 1500,
          resoY: 843,
          xPos: -10.8532,
          zPos: 10.0428,
          yPos: 0.8826,
          isPredefinedCamera: false,
          is_rendered: false,
          focusXPos: null,
          focusYPos: null,
          focusZPos: null,
          canvas_width: 1344,
          canvas_height: 732,
          sensor_width: 20,
          sensor_height: 11.25,
          fov_axis: 'Vertical',
          gate_fit: 'Overscan',
          dpi: 72,
          tags: ['0_Straight'],
          sequence_number: 4,
        },
        {
          thumbnail_link:
            'https://media-stag.imagine.io/media/public/retail_static/HotspotThumb_hotspot1-cam2_filmic.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEA4aCXVzLWVhc3QtMSJIMEYCIQCdejv7ap1%2FPZtm9rDdAhwA8sdaKHPxS%2FY4wX8f5tGcpgIhAPr7%2F1MxJN1cC4uJWrDF1EaOLktryneLyOgwJRTufRzyKvsCCCcQARoMNDg5OTEwNzg0NjY2IgwZZrA5XlTOsRC7j8Iq2AIU3IcQcUmtkZpmZ%2Bbykxy73jWCt1vfEkNw5KlM9PA4cEWjQpRU91gNXcDBcYTZTSZ%2BFuOEJYrO2TUBNHP91r0fCyLUQIhAjz25PBi0hkLre5USOUkLhXJU4sxVLAvVQvaGHgqW4fQ7caZf%2FwLQ7KtcbnSmbt2rBIEaH5xHeCDyAS6py19bQJoKxPjSxWnqnNxTJy1NtWFZQRzgVr0lSnZ%2FXpDwVL7X4V7HfMcLk8W8jSZZalYsdUH%2BdJoaLfjxOO1Uwbs2AWgVYO37DFrb%2F3ySXDN545Qat3WFdgBueffRFP8EHbCjE3yV88Ime1FbemcpAHJCKPvb5F9u7Cn2VG1qDFbuNnoJ1%2BxRimqbtzLG82bgCZG4CzSRrun02imibhYV5Uiob7ZHp5tzt1kV3h4SE5puAOL9wuaxNoIyjbKAxsbR3kZbFAUaGUWI8omSUcGa3tXc9lmuaDCm6rq2BjqyAr39mb%2Folc4rrcH9NEY3lM9%2BVAX57%2BiRPrzenVzLZ6m4OL5%2BrWmuKTNFf5%2B1%2FCh%2FMEBRqoGZVmQ01N1IQQw37rERe2EfKkE1GcB6oMrzkaeg31Mq2bRCCGXK8tKvpFcm%2BA%2FLcQbuCvOuDdjxfR%2BhbeVSSSMqoV1Yf7gb%2FFBhmdE%2B1wtQxsU6BmJiL3aWetdLAEn9oHxDtH%2F%2Bc2eC6grmIPKYDBTkUdUGHVBtQgAt5IhHbGHKsiWwTL6ztu13tm3Cx%2BbLwnJIbtnBHd%2FnX0H6Lv%2FWtYOeET7drbKZEHMF2%2FwjrxY%2BTSr69Qy6RbwksK8w9pexeo0ybrSfplSqAqq1upoeHR9I3o3ytBG%2FKtv2Bcuu8xLtP6ADo9sPeZjrcXwucgSa5y9fujffNThG2LRqLrzuaQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240828T080955Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIAXEEHVKKNEQPRQXC2%2F20240828%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=3cbf78bc54f3dda5fdb3b518de3f6a3e3c03220fa7b7467428923be370d68507',
          id: 'ca561679-6098-4f3d-bc49-6db76f110361',
          cameraName: 'hotspot1-cam2',
          distanceToSet: 2.066,
          fov: 40,
          horizontalFov: '0.00000000000000',
          xTransRot: 23.88,
          yTransRot: 200.934,
          zTransRot: 0,
          centerObjectxPos: -8.9611,
          centerObjectyPos: -0.0312,
          centerObjectzPos: 8.779,
          isCameraCorrection: false,
          lensShiftY: 0,
          cameraHeight: 0.81,
          cameraRotX: 0,
          cameraRotZ: 0,
          focalLength: 15.4546,
          isdepthOfField: false,
          selectedObjectName: '',
          blurIntensity: 5,
          resoX: 1500,
          resoY: 843,
          xPos: -8.2861,
          zPos: 10.5434,
          yPos: 0.8051,
          isPredefinedCamera: false,
          is_rendered: false,
          focusXPos: null,
          focusYPos: null,
          focusZPos: null,
          canvas_width: 1344,
          canvas_height: 732,
          sensor_width: 20,
          sensor_height: 11.25,
          fov_axis: 'Vertical',
          gate_fit: 'Overscan',
          dpi: 72,
          tags: ['0_Straight'],
          sequence_number: 3,
        },
      ],
    },
    {
      linked_product_blender_id: 18959,
      cameraInfo: [
        {
          thumbnail_link:
            'https://media-stag.imagine.io/media/public/retail_static/HotspotThumb_hotspot2-cam1_filmic.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEA4aCXVzLWVhc3QtMSJIMEYCIQCdejv7ap1%2FPZtm9rDdAhwA8sdaKHPxS%2FY4wX8f5tGcpgIhAPr7%2F1MxJN1cC4uJWrDF1EaOLktryneLyOgwJRTufRzyKvsCCCcQARoMNDg5OTEwNzg0NjY2IgwZZrA5XlTOsRC7j8Iq2AIU3IcQcUmtkZpmZ%2Bbykxy73jWCt1vfEkNw5KlM9PA4cEWjQpRU91gNXcDBcYTZTSZ%2BFuOEJYrO2TUBNHP91r0fCyLUQIhAjz25PBi0hkLre5USOUkLhXJU4sxVLAvVQvaGHgqW4fQ7caZf%2FwLQ7KtcbnSmbt2rBIEaH5xHeCDyAS6py19bQJoKxPjSxWnqnNxTJy1NtWFZQRzgVr0lSnZ%2FXpDwVL7X4V7HfMcLk8W8jSZZalYsdUH%2BdJoaLfjxOO1Uwbs2AWgVYO37DFrb%2F3ySXDN545Qat3WFdgBueffRFP8EHbCjE3yV88Ime1FbemcpAHJCKPvb5F9u7Cn2VG1qDFbuNnoJ1%2BxRimqbtzLG82bgCZG4CzSRrun02imibhYV5Uiob7ZHp5tzt1kV3h4SE5puAOL9wuaxNoIyjbKAxsbR3kZbFAUaGUWI8omSUcGa3tXc9lmuaDCm6rq2BjqyAr39mb%2Folc4rrcH9NEY3lM9%2BVAX57%2BiRPrzenVzLZ6m4OL5%2BrWmuKTNFf5%2B1%2FCh%2FMEBRqoGZVmQ01N1IQQw37rERe2EfKkE1GcB6oMrzkaeg31Mq2bRCCGXK8tKvpFcm%2BA%2FLcQbuCvOuDdjxfR%2BhbeVSSSMqoV1Yf7gb%2FFBhmdE%2B1wtQxsU6BmJiL3aWetdLAEn9oHxDtH%2F%2Bc2eC6grmIPKYDBTkUdUGHVBtQgAt5IhHbGHKsiWwTL6ztu13tm3Cx%2BbLwnJIbtnBHd%2FnX0H6Lv%2FWtYOeET7drbKZEHMF2%2FwjrxY%2BTSr69Qy6RbwksK8w9pexeo0ybrSfplSqAqq1upoeHR9I3o3ytBG%2FKtv2Bcuu8xLtP6ADo9sPeZjrcXwucgSa5y9fujffNThG2LRqLrzuaQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240828T081007Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIAXEEHVKKNEQPRQXC2%2F20240828%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=17139dc21550030b866e59a4c9cf7916f72e80a2ba65c79b3040a53180af123a',
          id: '4ea34c26-4dad-439a-b472-a71ab271e003',
          cameraName: 'hotspot2-cam1',
          distanceToSet: 1.5615,
          fov: 40,
          horizontalFov: '0.00000000000000',
          xTransRot: 30.66,
          yTransRot: 119.9341,
          zTransRot: 0,
          centerObjectxPos: -10.3069,
          centerObjectyPos: -0.0049,
          centerObjectzPos: 7.7546,
          isCameraCorrection: false,
          lensShiftY: 0,
          cameraHeight: 0.79,
          cameraRotX: 0,
          cameraRotZ: 0,
          focalLength: 15.4546,
          isdepthOfField: false,
          selectedObjectName: '',
          blurIntensity: 5,
          resoX: 1500,
          resoY: 843,
          xPos: -11.471,
          zPos: 8.4249,
          yPos: 0.7914,
          isPredefinedCamera: false,
          is_rendered: false,
          focusXPos: null,
          focusYPos: null,
          focusZPos: null,
          canvas_width: 1344,
          canvas_height: 732,
          sensor_width: 20,
          sensor_height: 11.25,
          fov_axis: 'Vertical',
          gate_fit: 'Overscan',
          dpi: 72,
          tags: ['0_Straight'],
          sequence_number: 2,
        },
        {
          thumbnail_link:
            'https://media-stag.imagine.io/media/public/retail_static/HotspotThumb_hotspot2-cam2_filmic.jpg?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEA4aCXVzLWVhc3QtMSJIMEYCIQCdejv7ap1%2FPZtm9rDdAhwA8sdaKHPxS%2FY4wX8f5tGcpgIhAPr7%2F1MxJN1cC4uJWrDF1EaOLktryneLyOgwJRTufRzyKvsCCCcQARoMNDg5OTEwNzg0NjY2IgwZZrA5XlTOsRC7j8Iq2AIU3IcQcUmtkZpmZ%2Bbykxy73jWCt1vfEkNw5KlM9PA4cEWjQpRU91gNXcDBcYTZTSZ%2BFuOEJYrO2TUBNHP91r0fCyLUQIhAjz25PBi0hkLre5USOUkLhXJU4sxVLAvVQvaGHgqW4fQ7caZf%2FwLQ7KtcbnSmbt2rBIEaH5xHeCDyAS6py19bQJoKxPjSxWnqnNxTJy1NtWFZQRzgVr0lSnZ%2FXpDwVL7X4V7HfMcLk8W8jSZZalYsdUH%2BdJoaLfjxOO1Uwbs2AWgVYO37DFrb%2F3ySXDN545Qat3WFdgBueffRFP8EHbCjE3yV88Ime1FbemcpAHJCKPvb5F9u7Cn2VG1qDFbuNnoJ1%2BxRimqbtzLG82bgCZG4CzSRrun02imibhYV5Uiob7ZHp5tzt1kV3h4SE5puAOL9wuaxNoIyjbKAxsbR3kZbFAUaGUWI8omSUcGa3tXc9lmuaDCm6rq2BjqyAr39mb%2Folc4rrcH9NEY3lM9%2BVAX57%2BiRPrzenVzLZ6m4OL5%2BrWmuKTNFf5%2B1%2FCh%2FMEBRqoGZVmQ01N1IQQw37rERe2EfKkE1GcB6oMrzkaeg31Mq2bRCCGXK8tKvpFcm%2BA%2FLcQbuCvOuDdjxfR%2BhbeVSSSMqoV1Yf7gb%2FFBhmdE%2B1wtQxsU6BmJiL3aWetdLAEn9oHxDtH%2F%2Bc2eC6grmIPKYDBTkUdUGHVBtQgAt5IhHbGHKsiWwTL6ztu13tm3Cx%2BbLwnJIbtnBHd%2FnX0H6Lv%2FWtYOeET7drbKZEHMF2%2FwjrxY%2BTSr69Qy6RbwksK8w9pexeo0ybrSfplSqAqq1upoeHR9I3o3ytBG%2FKtv2Bcuu8xLtP6ADo9sPeZjrcXwucgSa5y9fujffNThG2LRqLrzuaQ%3D%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240828T081018Z&X-Amz-SignedHeaders=host&X-Amz-Expires=300&X-Amz-Credential=ASIAXEEHVKKNEQPRQXC2%2F20240828%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=7332c6a47dd05a364eb960e5861d1b36069ac796524d23e1adf153ef2aea24cb',
          id: 'ca561679-6098-4f3d-bc49-6db76f110361',
          cameraName: 'hotspot1-cam2',
          distanceToSet: 2.066,
          fov: 40,
          horizontalFov: '0.00000000000000',
          xTransRot: 23.88,
          yTransRot: 200.934,
          zTransRot: 0,
          centerObjectxPos: -8.9611,
          centerObjectyPos: -0.0312,
          centerObjectzPos: 8.779,
          isCameraCorrection: false,
          lensShiftY: 0,
          cameraHeight: 0.81,
          cameraRotX: 0,
          cameraRotZ: 0,
          focalLength: 15.4546,
          isdepthOfField: false,
          selectedObjectName: '',
          blurIntensity: 5,
          resoX: 1500,
          resoY: 843,
          xPos: -8.2861,
          zPos: 10.5434,
          yPos: 0.8051,
          isPredefinedCamera: false,
          is_rendered: false,
          focusXPos: null,
          focusYPos: null,
          focusZPos: null,
          canvas_width: 1344,
          canvas_height: 732,
          sensor_width: 20,
          sensor_height: 11.25,
          fov_axis: 'Vertical',
          gate_fit: 'Overscan',
          dpi: 72,
          tags: ['0_Straight'],
          sequence_number: 3,
        },
      ],
    },
  ],
  hasNewLightInfo: true,
  datetime: '2024-08-28T07:50:10.039Z',
  filteroptions: [
    {
      id: 2589,
      created_at: '2022-09-16T12:40:58.034021+05:30',
      updated_at: '2022-09-16T12:40:58.034033+05:30',
      name: 'Open Floor Plan',
      filter_label: 23,
      organization: null,
    },
    {
      id: 2577,
      created_at: '2022-08-31T16:59:04.774182+05:30',
      updated_at: '2022-08-31T16:59:04.774201+05:30',
      name: 'Minimalistic',
      filter_label: 24,
      organization: null,
    },
  ],
  room_type: '2',
  tags: ['Premium Rendering', 'Dimensions', 'Staging', 'spacious', 'great hall'],
};
